import SvgIcon from '@mui/material/SvgIcon'
import FormControlLabel from '@mui/material/FormControlLabel'
import MUICheckbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import React from 'react'
import { ReactComponent as CheckedIcon } from '../../../assets/images/checkbox-checked.svg'
import { ReactComponent as UncheckedIcon } from '../../../assets/images/checkbox-unchecked.svg'

const CheckboxUncheckedIcon = (
    <SvgIcon component={UncheckedIcon} inheritViewBox sx={{ fontSize: '16px' }} color="inherit" />
)
const CheckboxCheckedIcon = <SvgIcon component={CheckedIcon} inheritViewBox sx={{ fontSize: '16px' }} color="inherit" />

type CheckboxProps = {
    label: string
    checked: boolean
    onCheck: () => void
}

const Checkbox = ({ label, checked, onCheck }: CheckboxProps) => {
    return (
        <FormControlLabel
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: 1,
                color: checked ? 'figma.primary' : 'figma.grayscale.textHier2',
                '&:hover': {
                    color: 'figma.primary',
                },
                marginLeft: 0,
                marginRight: 0,
            }}
            control={
                <MUICheckbox
                    size="small"
                    checked={checked}
                    onChange={onCheck}
                    icon={CheckboxUncheckedIcon}
                    checkedIcon={CheckboxCheckedIcon}
                    sx={{
                        pointerEvents: 'none',
                        p: 0,
                        color: 'inherit',
                        mt: '3px',
                    }}
                />
            }
            label={
                <Typography variant="16x400" color="inherit" sx={{ mt: -0.25 }}>
                    {label}
                </Typography>
            }
        />
    )
}

export default Checkbox
